<template>
  <el-dialog
    width="104.375rem"
    :close-on-click-modal="false"
    :visible.sync="lookPaperVisible"
    class="inner-dialog"
  >
    <template slot="title">
      <div
        style="display: flex;justify-content: space-between;align-items: center;"
      >
        <div style="font-size: 20px;">
          {{ isEdit ? "编辑试卷" : "查看试卷" }}
        </div>
        <el-button
          type="primary"
          v-if="isEdit"
          style="margin-right: 40px;"
          @click="submitPaper"
          >确定</el-button
        >
      </div>
    </template>
    <div class="grade-box">
      <!-- <el-tabs
        v-if="!isEdit"
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane label="理论考试" name="1"></el-tab-pane>
        <el-tab-pane label="实操考试" name="2"></el-tab-pane>
      </el-tabs> -->
      <div class="all" v-if="activeName === '1'">
        <div class="left">
          <div class="test-title">
            <div class="one-line">{{ currentPaperName }}</div>
            <div class="two-line">
              <span>总分：{{ currentPaperScore }}分</span>
              <span>得分：{{ rowData.examScore }}分</span>
            </div>
          </div>
          <div class="normal-area" v-for="(paper, key) in paperData" :key="key">
            <div class="tips">{{ paper.title }}(共{{ paper.score }}分)</div>

            <div
              class="test-style"
              v-for="(item, index) in paper.data"
              :key="index"
              :id="item.questionsId"
            >
              <div class="header-title" style="display: flex;">
                <div>
                  <i
                    v-if="answer[item.questionsId] == item.questionAnswer"
                    class="el-icon-check"
                    style="color: #2ea93aff"
                  ></i>
                  <i v-else class="el-icon-close" style="color: #f34c4cff"></i>
                  {{ index + 1 }}.{{ item.questionStem }}
                </div>
                <div>{{ item.score }}分</div>
              </div>
              <div
                :style="{
                  margin: '0.5rem 1.25rem',
                  color:
                    answer[item.questionsId] == item.questionAnswer
                      ? '#2EA93AFF'
                      : '#F34C4CFF'
                }"
              >
                正确答案：{{ item.answer }}
              </div>
              <div class="exam-option">
                <el-checkbox-group
                  @input="val => answerChange(val, item)"
                  class="exam-radio"
                  v-if="item.questionType == 3"
                  v-model="answerData[item.questionsId]"
                  :disabled="!isEdit"
                >
                  <el-checkbox
                    v-for="(option, optionKey) in item.qaList"
                    :key="optionKey"
                    :label="option.answerId"
                  >
                    {{ option.answerFLag }}.{{ option.answerStem }}</el-checkbox
                  >
                </el-checkbox-group>
                <!-- 单选 -->
                <el-radio-group
                  v-else
                  @input="val => answerChange(val, item)"
                  class="exam-radio"
                  v-model="answerData[item.questionsId]"
                  v-removeAriaHidden
                  :disabled="!isEdit"
                >
                  <el-radio
                    v-for="(option, optionKey) in item.qaList"
                    :key="optionKey"
                    :label="option.answerId"
                  >
                    {{ option.answerFLag }}.{{ option.answerStem }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right-bottom">
            <div class="header-title">
              <div class="tips-text">试卷信息</div>
            </div>
            <div class="bottom-content">
              <div v-for="(paper, key) in paperData" :key="key">
                <div class="tips">
                  <div>{{ paper.title }}</div>
                </div>
                <div class="numbers-area">
                  <a
                    v-for="(item, index) in paper.data"
                    :key="index"
                    :class="[
                      'number',
                      { currentNum: currentId == item.questionsId },
                      answer[item.questionsId] == item.questionAnswer
                        ? 'is-right'
                        : 'is-error'
                    ]"
                    @click="scrollTo(item.questionsId)"
                    >{{ index + 1 }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="all" v-else>
        实操考试
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { lookPaperAnswer } from "@/api/manage";
import { getExamination, updateAnswer } from "@/api/system";
export default {
  data() {
    return {
      activeName: "1",
      lookPaperVisible: false,
      currentPaperScore: 0,
      paperScore: 0,
      currentPaperName: "",
      // 选择用
      answerData: {},
      // 校验、提交用
      answer: {},
      isEdit: false,
      currentId: null,
      paperData: {
        radio: { data: [], score: 0, title: "一、单选题" },
        judge: { data: [], score: 0, title: "二、判断题" },
        more: { data: [], score: 0, title: "三、多选题" }
      },
      questionTypeOptions: {
        1: "radio",
        2: "judge",
        3: "more"
      },
      rowData: {}
    };
  },
  computed: {},
  methods: {
    async open(row, type) {
      this.reset();
      this.rowData = row;
      this.isEdit = type == "edit";
      await this.getPaper(row.examinationId);
      this.lookPaperVisible = true;
    },
    handleClick(val) {},
    reset() {
      this.paperData = {
        radio: { data: [], score: 0, title: "一、单选题" },
        judge: { data: [], score: 0, title: "二、判断题" },
        more: { data: [], score: 0, title: "三、多选题" }
      };
      this.currentPaperScore = 0;
      this.activeName = "1";
      this.currentId = null;
      this.answerData = {};
      this.answer = {};
      this.rowData = {};
    },
    getPaperScore() {
      var score = 0;
      this.paperData.radio.data.forEach((item, key) => {
        if (this.answerData[item.questionsId] == item.questionAnswer) {
          score += Number(item.score);
        }
      });
      this.paperData.more.data.forEach((item, key) => {
        if (this.answerData[item.questionsId] == item.questionAnswer) {
          score += Number(item.score);
        }
      });
      this.paperData.judge.data.forEach((item, key) => {
        if (this.answerData[item.questionsId] == item.questionAnswer) {
          score += Number(item.score);
        }
      });
      return score;
    },
    answerChange(val, item) {
      this.answer[item.questionsId] =
        item.questionType == 3 ? val.sort((a, b) => a - b).join(",") : val;
      this.$forceUpdate();
    },
    answerGet(item, option) {
      const answer = item.split(",");
      var res = [];
      for (let i = 0; i < answer.length; i++) {
        for (let j = 0; j < option.length; j++) {
          if (answer[i] == option[j].answerId) {
            res.push(option[j].answerFLag);
          }
        }
      }
      return res.join(",");
    },
    async getPaper(id) {
      const res = await getExamination(id);
      this.currentPaperName = res.data.data.name;
      const response = await lookPaperAnswer(res.data.data.questionPaperId);
      this.rowData.passScore = res.data.data.passScore;
      const rowAnswer = JSON.parse(this.rowData.answer) || {};
      this.answer = rowAnswer;
      response.data.data.forEach(item => {
        if (item.questionType === "3") {
          this.answerData[item.questionsId] = rowAnswer[item.questionsId]
            ? rowAnswer[item.questionsId].split(",").map(i => Number(i))
            : [];
        } else {
          this.answerData[item.questionsId] = rowAnswer[item.questionsId]
            ? Number(rowAnswer[item.questionsId])
            : "";
        }

        this.currentPaperScore += Number(item.score) | 0;
        this.paperData[this.questionTypeOptions[item.questionType]].data.push({
          ...item,
          ...{
            answer: this.answerGet(item.questionAnswer, item.qaList)
          }
        });
        this.paperData[
          this.questionTypeOptions[item.questionType]
        ].score += Number(item.score);
      });

      this.currentPaperScore = Number(this.currentPaperScore.toFixed(1));
    },
    answerFormat() {
      let res = {};
      for (let i in this.answer) {
        if (this.answer[i] !== "") {
          res[i] = this.answer[i];
        }
      }
      return res;
    },
    submitPaper() {
      console.log(this.answerFormat());
      this.$confirm(
        `修改后成绩为${this.getPaperScore()}分（满分${
          this.currentPaperScore
        }分,${this.rowData.passScore || 0}分及格），确定保存本次编辑吗?`,
        "信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          const answer = this.answerFormat();
          await updateAnswer({
            questionMemberInfoId: this.rowData.questionMemberInfoId,
            answer
          });
          this.$emit("success");
          this.lookPaperVisible = false;
        })
        .catch(() => {});
    },
    scrollTo(id) {
      this.currentId = id;
      document.getElementById(id).scrollIntoView({
        block: "start",
        behavior: "instant"
      });
    }
  }
};
</script>
<style lang="less" scoped>
.inner-dialog {
  overflow: hidden;
  /deep/ .el-dialog {
    margin: 0 !important;
    margin-left: 15rem !important;
    margin-top: 78px !important;
    height: calc(100vh - 90px);
    // background-color: #E9F1FF;
    // border-radius:none;
    // -webkit-box-shadow:none!important;
    // box-shadow:none!important;
  }

  /deep/ .el-dialog__body {
    padding: 1.25rem;
    height: calc(100vh - 184px);
  }
  .grade-box {
    display: flex;
    height: 100%;
    flex-direction: column;
  }
  .all {
    flex: 1;
    overflow: hidden;
    margin-bottom: 12px;
    display: flex;
    .left {
      width: 79%;
      height: 100%;
      border: 1px solid #e5eaf4;
      padding: 1.875rem 1.25rem 1.25rem 1.25rem;
      box-sizing: border-box;
      overflow: auto;
      margin-right: 1%;

      .test-title {
        text-align: center;
        background: #f6f9ff;
        border: 1px solid #d1daec;
        border-radius: 0.625rem;
        width: 25rem;
        height: 4.375rem;
        margin: 0 auto;
        padding-top: 0.5rem;
        box-sizing: border-box;

        .one-line {
          font-size: 1.25rem;
          font-family: PingFangSC-Regular, PingFang SC;
          // font-weight: 500;
          color: #434449;
        }

        .two-line {
          span {
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            // font-weight: 500;
            color: #919398;
          }
        }
      }

      .normal-area {
        .tips {
          font-size: 0.875rem;
          font-family: PingFangSC-Regular, PingFang SC;
          // font-weight: 500;
          color: #434449;
          margin: 1rem 0;
        }

        .test-style {
          border: 1px solid #e5eaf4;
          box-sizing: border-box;
          margin-bottom: 0.5rem;

          .header-title {
            display: flex;
            justify-content: space-between;
            padding: 0 1.25rem;
            background: #fafafa;
            // height: 2.8125rem;
            line-height: 2.8125rem;
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            // font-weight: 500;
            color: #434449;
          }

          .exam-option {
            padding: 1rem 1.25rem;
            /deep/ .exam-radio {
              display: block;
              .el-radio {
                display: block;
                margin-bottom: 20px;
                width: max-content;
                // .el-radio__input {
                //   vertical-align: baseline;
                // }
                .el-radio__inner {
                  border: 1px solid #c4cee1ff;
                }
                // .el-radio__label {
                //   color: #475775ff;
                //   width: max-content;
                // }
              }
              .el-checkbox {
                display: block;
                margin-bottom: 20px;
                width: max-content;
                .el-checkbox__input {
                  vertical-align: baseline;
                }
                .el-checkbox__inner {
                  border: 1px solid #c4cee1ff;
                }
                .el-checkbox__label {
                  color: #475775ff;
                  width: max-content;
                }
              }
            }
          }
        }

        .test-style:last-child {
          margin-bottom: 0;
        }
      }
    }

    .right {
      width: 20%;
      display: flex;
      flex-direction: column;

      .right-top {
        border: 1px solid #e5eaf4;
        margin-bottom: 1.25rem;
        width: 20.625rem;
        padding-top: 1.875rem;
        box-sizing: border-box;

        .set-grade {
          background: #1890ff;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffffff;
          margin-bottom: 1.25rem;
          cursor: pointer;
        }

        .submit-test {
          border: 1px solid #1890ff;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #1890ff;
          cursor: pointer;
        }

        div {
          width: 16.25rem;
          height: 3.125rem;
          text-align: center;
          line-height: 3.125rem;
          border-radius: 0.1875rem;
          box-sizing: border-box;
          margin: 0 auto;
        }
      }

      .right-bottom {
        border: 1px solid #e5eaf4;
        padding: 1rem 1.25rem 0 1.25rem;
        height: 100%;
        box-sizing: border-box;
        overflow: auto;

        .header-title {
          display: flex;
          justify-content: space-between;
          padding-left: 0.25rem;
          margin-bottom: 1rem;
          align-items: center;

          .tips-text {
            font-size: 1rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #434449;
          }

          .right-text {
            // background: #2D8CF0;
            // opacity: 0.2;
            border-radius: 0.1875rem;
            background: rgba(45, 140, 240, 0.2);
            width: 3.75rem;
            height: 1.75rem;
            line-height: 1.75rem;
            text-align: center;
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #1890ff;
            cursor: pointer;
          }
        }

        .bottom-content {
          .tips {
            display: flex;
            justify-content: space-between;
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #434449;
            margin-bottom: 1rem;

            // padding: 0 1.25rem;
            .remove {
              color: #c8c8c8;
              cursor: pointer;
            }
          }

          .numbers-area {
            display: flex;
            // justify-content:space-between;
            flex-wrap: wrap;

            .number {
              // width: %;
              // width: 3.125rem;
              width: 18%;
              margin-right: 1%;
              height: 2.1875rem;
              line-height: 2.1875rem;
              text-align: center;
              background: #ffffff;
              border: 1px solid #d1daec;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #434449;
              margin-bottom: 0.5rem;
              cursor: pointer;
              text-decoration: none;
              box-sizing: border-box;
            }
            .is-error {
              background-color: #f34c4cff;
              color: #fff;
            }
            .is-right {
              background-color: #2ea93aff;
              color: #fff;
            }
            .currentNum {
              background: #f6f9ff;
              color: rgba(24, 144, 255, 1);
              border: 1px solid rgba(24, 144, 255, 1);
            }

            .number:nth-child(5n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/GradeManage/TheoryDialog.vue